import { TransactionModelStatusEnum } from "./generated/api"

export const suggestions = [
	{
		emoji: "😨",
		label: "۱۰ راه کاهش استرس رو بگو.",
	},
	{
		emoji: "😱",
		label: "راه های مقابله با ترس",
	},
	{
		emoji: "🌟",
		label: "لیست بزرگ ترین ستاره های جهان را به من بده.",
	},
	{
		emoji: "🍢",
		label: "امروز غذا چی درست کنم؟ ",
	},
	{
		emoji: "👷‍♂️",
		label: "به من کمک کن تا در کارم با انگیزه بمانم. ",
	},
	{
		emoji: "🎂",
		label: "یک پیام تبریک تولد بنویس.",
	},
	{
		emoji: "🤳",
		label: "چجوری در اینستاگرام ویوی بیشتری بگیرم؟",
	},
	{
		emoji: "🎼",
		label: "بهترین رباعیات خیام رو بگو.",
	},
	{
		emoji: "🇮🇷",
		label: "آداب و رسوم ازدواج در ایران چیه؟ ",
	},
	{
		emoji: "🇮🇷",
		label: "غذاهای سنتی ایرانی رو معرفی کن.",
	},
	{
		emoji: "🏞️",
		label: "چطور می‌تونم یه انشاء در مورد طبیعت بنویسم؟",
	},
	{
		emoji: "🥗",
		label: "رای لاغری چه رژیم غذایی‌ای مناسبه؟",
	},
	{
		emoji: "🌆",
		label: "چطور می‌تونم برای سفر به شیراز برنامه‌ریزی کنم؟",
	},
	{
		emoji: "🏙️",
		label: "جاهای دیدنی تهران رو معرفی کن.",
	},
	{
		emoji: "⌛",
		label: "تکنیک های مدیریت زمان رو به من معرفی کن.",
	},
]

export const suggestions2 = [
	{
		label: "چگونه می‌توانم خواب بهتری داشته باشم؟",
		emoji: "😴",
	},
	{
		label: "راهکارهای افزایش تمرکز چیست؟",
		emoji: "🎯",
	},
	{
		label: "چگونه می‌توانم انگیزه خود را بالا نگه دارم؟",
		emoji: "💪",
	},
	{
		label: "رازهای موفقیت چیست؟",
		emoji: "🏆",
	},
	{
		label: "چگونه می‌توانم از پس چالش‌های زندگی بربیایم؟",
		emoji: "🌟",
	},
	{
		label: "چگونه می‌توانم ارتباطات اجتماعی‌ام را بهبود بخشم؟",
		emoji: "🌐",
	},
	{
		label: "راهکارهای مدیریت زمان چیست؟",
		emoji: "⏰",
	},
	{
		label: "بهترین روش‌های یادگیری زبان جدید چیست؟",
		emoji: "🌍",
	},
	{
		label: "چگونه می‌توانم خلاقیت خود را تقویت کنم؟",
		emoji: "🎨",
	},
	{
		label: "بهترین فعالیت‌ها برای افزایش سلامت روحی چیست؟",
		emoji: "🧘‍♂️",
	},
	{
		label: "چگونه می‌توانم از تکنولوژی به شکل بهینه استفاده کنم؟",
		emoji: "💻",
	},
	{
		label: "چگونه می‌توانم عزت نفس خود را بالا ببرم؟",
		emoji: "🌈",
	},
	{
		label: "بهترین روش‌های تغذیه سالم چیست؟",
		emoji: "🍏",
	},
	{
		label: "چگونه می‌توانم از اینترنت درآمد کسب کنم؟",
		emoji: "💸",
	},
]

export const TransactionStatusList = [
	{ label: "پرداخت شده", value: TransactionModelStatusEnum.Redemmed },
	{ label: "لغو شده", value: TransactionModelStatusEnum.Failed },
	{ label: "در حال انتظار", value: TransactionModelStatusEnum.Pending },
	{ label: "در انتظار تایید", value: TransactionModelStatusEnum.Verified },
]
